import * as moment from 'moment'
import * as LeadPostTypes from '../lead-posts/types'
import * as Types from './types'

export const update = (items: Types.CCLeadContent[], index: number): object[] => {
    const newArr = [...items]
    newArr[index].is_active = !newArr[index].is_active
    return newArr;
}

interface CCLeadFormFields extends LeadPostTypes.FormFields {
  editor_state?: any,
  styles?: any,

}

export const asFormFields = (lp: Types.CCLeadContent): CCLeadFormFields => {
  return {
    category_type_id: lp.category_type_id,
    community_partner_code: lp.community_partner_code,
    description: lp.description,
    editor_state: lp.editor_state,
    end_date: moment(lp.end_date),
    feature_type: lp.feature_type,
    id: lp.id ? lp.id.toString() : null,
    image_url: lp.image_url,
    rank: lp.rank,
    site_name: lp.name,
    start_date: moment(lp.start_date),
    styles: lp.styles,
    title: lp.title,
    url: lp.url,
  }
}

export const displayText = (type: string) => {
  if (type === 'Promotion' || type === 'Lead Text') {
    return type
  } else {
    return type.split(' ')[1]
  }
}



// WEBPACK FOOTER //
// ./src/pages/content-calendar/utils.ts